import { Formik } from "formik";
import Input from "../Components/Input/Input";
import Select from "../Components/Input/Select/Select";
import TextEditor from "../Components/Input/TextEditor/TextEditor";
import Button from "../Components/Buttons";
import { feedbackFormDefaultValue, feedbackFormSchema } from "./schema";
import { useRef } from "react";
import Loader from '../Components/Lottie';
import loader from '../Assets/json/spinner.json';


export default function FeedbackForm({ countries, createFeedbackHandler, creatingFeedback }) {
  const formik = useRef();




  const reasons = [
    { value: "New to donate money", displayedValue: "Donation of Cash" },
  ];




  return (
    <Formik
      initialValues={feedbackFormDefaultValue}
      validationSchema={feedbackFormSchema}
      onSubmit={(values, hooks) => {
       createFeedbackHandler(values)
      }}
      innerRef={formik}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        setFieldValue,
        resetForm,
      }) => {

        const setBodyHandler = (value) => {
          setFieldValue('body', value)
        };

        return (
          <form className="sm:p-6" onSubmit={handleSubmit}>
            <div className="sm:flex">
              <Input
                showError={errors.firstName}
                error={
                  errors.firstName && [
                    errors.firstName.replace("firstName", "First name"),
                  ]
                }
                label="First Name*"
                name={"firstName"}
                onChange={handleChange}
                // onBlur={handleBlur}
                value={values.firstName}
                required={true}
                placeholder="First Name"
              />
              <div className="p-2" />

              <Input
                label="Last Name*"
                showError={errors.lastName && touched.lastName}
                name={"lastName"}
                error={
                  errors.lastName && [
                    errors.lastName.replace("lastName", "Last name"),
                  ]
                }
                onChange={handleChange}
                value={values.lastName}
                required={true}
                placeholder="Last Name"
              />
            </div>
            <div className="p-2" />

            <div className="sm:flex">
              <Input
                label="Email*"
                showError={errors.email && touched.email}
                name={"email"}
                onChange={handleChange}
                value={values.email}
                error={errors?.email && [errors.email]}
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                type={"email"}
                required={true}
                placeholder="Example@email.com"
              />
              <div className="p-2 " />
              <Select
                required
                showError={errors.country && touched.country}
                options={countries}
                label="Country*"
                placeholder="Select Country"
                name={"country_id"}
                onChange={handleChange}
                error={
                  errors?.country && [
                    errors.country.replace("country_id", "Country name"),
                  ]
                }
                value={values.country_id}
              />
            </div>
            <div className="p-2" />

            <div className="sm:flex">
              <Input
                label="Subject*"
                showError={errors.subject && touched.subject}
                name={"subject"}
                onChange={handleChange}
                error={errors?.subject && [errors?.subject]}
                value={values.subject}
                placeholder="Subject"
                type={"text"}
                required={true}
              />
              <div className="p-2" />
              <Select
                showError={errors.reason && touched.reason}
                options={reasons}
                label="Reason*"
                name={"reason"}
                error={errors?.reason && [errors?.reason]}
                onChange={handleChange}
                value={values.reason}
                placeholder="Select Reason"
              />
            </div>
            <div className="p-2" />

            <TextEditor
              className="min-h-72 max-h-96"
              label="How can we Help?*"
              placeholder="Describe Issue"
              value={values.body}
              onChange={setBodyHandler}
            />

            {/* <div className={"text-chestNut"}>{state.error}</div> */}
            <div className="w-full mt-4 md:w-1/2 lg:w-523 lg:mt-10">
              <Button
                disabled={creatingFeedback || values?.body?.length < 20}
                type="submit"
              >
                <div className={"flex justify-center items-center w-full"}>
                  {creatingFeedback && (
                    <span className="flex items-center justify-center w-full py-4">
                      <span className="inline-block w-4 h-4">
                        <Loader loader={loader} />
                      </span>
                    </span>
                  )}
                  {!creatingFeedback && (
                    <span className="inline-block py-4 text-center text-xs font-ubuntu leading-14">
                      SUBMIT
                    </span>
                  )}
                </div>
              </Button>
            </div>
          </form>
        );
    
}}
    </Formik>
  );
}
